// ======================================================================
// File Name       : SuperUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead, { setSortState } from '../TableHead';
import { SUPERUSER } from '../../constants/PathConstants';
import PaginationCustom from '../Pagination';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';

const SuperUserList = ({ superuserList, enterpriseInfo, handleSortState, searchInfo, recordNum, startPosition,  getStartEndData, 
  handleMouseEnter, handleMouseLeave }) => {
  const thead = [
    { title: 'ログインID', sortBy: 1  , width:'20%'},
    { title: 'SuperUser名', sortBy: 0 , width:'20%' },
    { title: '企業名', sortBy: 2 , width:'20%'},
    { title: 'ロック状態', sortBy: 3, width:'10%'},
    { title: '操作', sortBy: null, width:'10%'},
  ];
  // table data
  let data = thead;
  if (searchInfo) {
    const sortBy = searchInfo.userSortType;
    const sortState = searchInfo.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  
  let superUserTableData = null;
  if (superuserList) {
    superUserTableData = superuserList.map((superuser, index) => {
      const link = `/${SUPERUSER}/${superuser.superuserSecernId}`;
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>{superuser.loginId}</td>
          <td>{superuser.superuserName}</td>
          <td>{superuser.enterpriseName}</td>
          <td className="text-center">
            {superuser.lockState === 1 &&
              <i className="bi bi-lock" />}
          </td>
          <td className="text-center padding-clear">
            <CustomLink
                className="margin-right-7 link-detail-edit"
                to={link}
                text="詳細"
              />  
          </td>
        </tr>
      );
    });
  }

  return (
    <div>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState.bind(this)} />
        </thead>
        <tbody>
          {superUserTableData}
        </tbody>
      </Table>
      <Col className="text-center">
        <PaginationCustom
          recordNum={recordNum}
          startPosition={startPosition}
          handlePageSelect={getStartEndData.bind(this)}
        />
      </Col>
    </div>
  );
};

export default SuperUserList;
